import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-select-file-view-dialog',
  templateUrl: './select-file-view-dialog.component.html',
  styleUrls: ['./select-file-view-dialog.component.css']
})
export class SelectFileViewDialogComponent implements OnInit {

  currentValue: string;
  options = [
    { title: "Liste", desc: "Eine Listenansicht von Dateien und Ordnern untereinander.", isSelected: false, value: FileViewModes.List },
    { title: "Kacheln", desc: "Eine Kachelansicht von Dateien und Ordnern in Form eines Gitter Layouts." , isSelected: false, value: FileViewModes.Tiles }
  ];

  constructor(
    private _dialogRef: MatDialogRef<SelectFileViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: string
  ) {
    this.currentValue = _data;
  }

  close(){
    this._dialogRef.close();
  }

  ngOnInit(): void {
  }

  selectOption(option: any){
    this.currentValue = option.value;
    this._dialogRef.close(option.value);
  }

}

export const FileViewModes = {
  "List": 1,
  "Tiles": 2
}
